export class PackingBomFilter {
    saleOrderIds: number[];
    unitId: number;
    itemName: number[];
    endCustomerId:number;
    itemSubCategoryId:number;
}